import { Link } from "react-router-dom";
import { Construction } from "lucide-react";
import Seo from "@/components/Seo";

export default function ComingSoon({ title, blurb }) {
  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-6 py-16">
      <Seo title={`${title} · Coming soon · Jesus Just Us`} description={blurb} noindex />
      <div className="max-w-xl text-center fade-up">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-burgundy text-cream mb-6">
          <Construction className="h-7 w-7" strokeWidth={1.5} />
        </div>
        <div className="overline text-burgundy">Coming soon</div>
        <h1 className="font-serif text-4xl text-jjblue mt-3">{title}</h1>
        <p className="mt-5 text-[var(--jj-text-secondary)] leading-relaxed">
          {blurb} We're building this section thoughtfully so it serves the family well.
          In the meantime, jump into the feed or a prayer group — there's plenty already happening.
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/feed" className="btn-primary" data-testid="cs-feed">Open the feed</Link>
          <Link to="/groups" className="btn-secondary" data-testid="cs-groups">Prayer groups</Link>
        </div>
      </div>
    </div>
  );
}
